import { useNavigate } from 'react-router-dom';

import { MM_ROUTE } from '@pages/MasterMechanic';

export const useMasterMechanic = () => {
  const navigate = useNavigate();

  const navigateMM = () => {
    navigate(MM_ROUTE);
  };

  const askModel = (modelId: string, isManuals?: boolean) => {
    const operatingMode = isManuals ? '&operating_mode=manual' : '';
    navigate(`${MM_ROUTE}?modelId=${modelId}${operatingMode}`);
  };

  return { navigateMM, askModel };
};
